import { Outlet } from '@remix-run/react';

export { loader } from './root-loader';

function App() {
  return <Outlet />;
}

export default App;
